import { jsx as _jsx } from "react/jsx-runtime";
import { extendBannerContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { forwardRef, useCallback } from "react";
import { useBanner, FooterLink, useCommonFooterLinks, useBannerStylesheet, LanguageSwitcher } from "../../..";
const BannerFooter = /*#__PURE__*/ forwardRef((_, ref)=>{
    const { FooterContainer } = useBannerStylesheet().extend(...extendBannerContentStylesheet);
    const banner = useBanner();
    const { isTcf, layout: { type }, footerDesign: { languageSwitcher: languageSwitcherChoice }, individualPrivacyOpen, onClose, i18n: { tcf }, isConsentRecord, languageSwitcher, set } = banner;
    const handleClose = useCallback((e)=>{
        onClose();
        e.preventDefault();
    }, [
        onClose
    ]);
    const { rows: links, render: renderLinks } = useCommonFooterLinks({
        onClose: isConsentRecord ? handleClose : undefined,
        putPoweredByLinkInRow: type === "banner" ? 0 : 1,
        row1: [
            process.env.IS_TCF === "1" && isTcf && !individualPrivacyOpen && /*#__PURE__*/ _jsx(FooterLink, {
                href: "#",
                onClick: ()=>set({
                        individualPrivacyOpen: true
                    }),
                children: tcf.vendorList
            }, "vendorList")
        ],
        row1End: [
            (languageSwitcher == null ? void 0 : languageSwitcher.length) > 0 && languageSwitcherChoice && languageSwitcherChoice !== "disabled" && /*#__PURE__*/ _jsx(LanguageSwitcher, {}, "languageSwitcher")
        ]
    });
    return /*#__PURE__*/ _jsx(FooterContainer, {
        ref: ref,
        children: /*#__PURE__*/ _jsx("div", {
            children: renderLinks(links)
        })
    });
});
export { BannerFooter };
